import {Injectable} from '@angular/core';
import {WebViewerOptions} from '@pdftron/webviewer';
import {firstValueFrom} from 'rxjs';
import {API} from '../../shared/constants/api.constants';
import {ErrorHandlingHttpClient} from '../../shared/services/error-handling-http-client.service';
import { map} from 'rxjs/operators';



@Injectable({ providedIn: 'root' })
export class PdftronKeyService {
  licenseKey = '';

  constructor(private errorHandlingHttpClient: ErrorHandlingHttpClient) {
  }
  async loadPdfLicense(): Promise<string> {
    if (!this.licenseKey || this.licenseKey.length === 0) {
      const key = await firstValueFrom(
        this.errorHandlingHttpClient.get(API.getPDFTronKey()).pipe(map(data => data.key))
      );
      this.licenseKey = atob(key);
    }
    return this.licenseKey;
  }
}

// Default WebViewer configuration
export function createPdfConfig(licenseKey: string): WebViewerOptions {
  return {
    path: '../webviewer',
    fullAPI: true,
    licenseKey,
    enableAzureWorkaround: true,
    enableAnnotations: false,
    disabledElements: [
      'toolbarGroup-Edit',
      'toolbarGroup-Annotate',
      'toolbarGroup-Shapes',
      'toolbarGroup-Insert',
      'toggleNotesButton'
    ]
  };
}
